import React from 'react';
import { IS_DEMO } from '../demo';

// Thin ribbon shown only in the static portfolio demo so visitors understand
// they are looking at sample data and that their changes are not persisted.
const DemoBanner = () => {
  if (!IS_DEMO) return null;
  return (
    <div
      role="note"
      style={{
        background: '#0d6efd',
        color: '#fff',
        textAlign: 'center',
        padding: '7px 14px',
        font: '500 13px system-ui, sans-serif',
        letterSpacing: '.01em',
        lineHeight: 1.4,
      }}
    >
      <strong>Live demo</strong> — open a text and{' '}
      <strong>click any word</strong> for an instant translation. Sample data; changes
      reset on refresh.{' '}
      <a
        href="https://github.com/semblable/Lingua_read2"
        target="_blank"
        rel="noreferrer"
        style={{ color: '#fff', textDecoration: 'underline', whiteSpace: 'nowrap' }}
      >
        source on GitHub →
      </a>
    </div>
  );
};

export default DemoBanner;
